import * as React from 'react';

export const offsetFromMiddleOfScreen = (
  e: React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>
) => {
  const middleOfScreen = window.innerWidth / 2;
  const boundingContext = e.currentTarget.getBoundingClientRect();

  return (
    boundingContext.left + e.currentTarget.clientWidth / 2 - middleOfScreen
  );
};

const getScrollOptions = () => {
  // smooth causes terrible lag on data rich documents
  const smoothBehaviourWillPerform = document.documentElement.offsetHeight < 10000;
  const behavior = smoothBehaviourWillPerform ? 'smooth' : 'instant';
  return { behavior, block: 'start', inline: 'start' };
};
/**
 * Returns the optimal scroll function, taking client support and current document size into account
 */
export const getWindowScroller = () => {

  if (!supportsScrollOptions()) {
    return (y: number) => window.scrollTo(0, y);
  }

  const bestOptions:{} = getScrollOptions();

  return (y: number) => window.scrollTo({ ...bestOptions, top: y, left: 0 });
};

export const scrollIntoView = (target:HTMLElement, options:{} = {}) => {
  const bestOptions:{} = getScrollOptions();
  target.scrollIntoView({...bestOptions, ...options, inline: 'end'});
};

/**
 * IE/Edge bug detection
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15534521/
 */
function supportsScrollOptions() {
  let supports = false;
  try {
    const div = document.createElement('div');
    div.scrollTo({
      top: 0,
      get behavior() {
        supports = true;
        return 'smooth' as any;
      }
    });
    // tslint:disable-next-line:no-empty
  } catch (err) {}
  return supports;
}

/**
 * Removes the child DOM elements of a given DOM element
 */
export const removeChildrenOf = (elementId: string) => {
  const root = document.getElementById(elementId);
  root.childNodes.forEach(n => n.remove());
};
